import { useMemo, useState, useSyncExternalStore } from 'react'
import { EMPTY_MODEL_STRING } from './settings'

const createFilterModelStore = (lsKey, emptyModel) => {
  let listeners = []

  return {
    subscribe: callback => {
      listeners.push(callback)
      return () => {
        listeners = listeners.filter(listener => listener !== callback)
      }
    },
    getSnapshot: () => {
      try {
        return localStorage.getItem(lsKey) || emptyModel
      } catch (error) {
        return emptyModel
      }
    },
    getServerSnapshot: () => {
      return emptyModel
    },
    update: filterModel => {
      localStorage.setItem(lsKey, JSON.stringify(filterModel))
      listeners.forEach(listener => listener())
    },
  }
}

const usePersistedFilterModel = (lsKey, emptyModel = EMPTY_MODEL_STRING) => {
  const [filterModelStore] = useState(createFilterModelStore(lsKey, emptyModel))
  const filterModelString = useSyncExternalStore(
    filterModelStore.subscribe,
    filterModelStore.getSnapshot,
    filterModelStore.getServerSnapshot
  )

  const filterModel = useMemo(() => {
    try {
      return JSON.parse(filterModelString) || undefined
    } catch (error) {
      return undefined
    }
  }, [filterModelString])

  return useMemo(() => [filterModel, filterModelStore.update], [filterModel, filterModelStore.update])
}

export default usePersistedFilterModel
